export default __webpack_public_path__ + "static/media/Freebooter's Legguards of the Roaring Jungle.ec8a2b13.jpg";